export const headerWithoutTableHeight = "211px";
export const headerWithTableHeight = "143px";